@if (message || show) {
  <div class="error-message"
    [class.error-message--friendly]="friendlyError">
    {{message || emptyText}}
    <ng-content></ng-content>
  </div>
}
